import React from "react";
import { Alert, CloseButton } from "reactstrap";
import ErrorBoundaryFactory from "./ErrorBoundaryFactory";

export default class GeneralErrorBoundary extends ErrorBoundaryFactory {
	constructor(props) {
		super(props);
		this.state = {
      isDetailOpen: false,
      isErrorClosed: false,
		}
	}

  onDetailClick = (e) => {
    e.preventDefault();
    this.setState({
      isDetailOpen: !this.state.isDetailOpen,
    });
  }

  onErrorClose = (e) => {
    e.preventDefault();
    this.setState({
      isErrorClosed: !this.state.isErrorClosed,
    });
  }

	render () {
    const { name, message, fileName, lineNumber } = (this?.props?.error ?? {});
    // if (!this.state.hasError) return this.props.children
    if (this.state.isErrorClosed) return null;
		return (
        <Alert color={"danger"}>
          <CloseButton className={"me-1"} onClick={this.onErrorClose}/>
          An error occurred in this part of the report.
          <a className={"ms-1"} href={"#"} onClick={this.onDetailClick}>Details</a>
          {this.state.isDetailOpen ? (
            <span className={"mx-2 italic "}>
              <i className="fa-solid fa-arrow-right"/> {`${name}: ${message}. ${Boolean(fileName) ? fileName : ''} ${Boolean(lineNumber) ? lineNumber : ''}`}
            </span>
          ) : null}
        </Alert>
		)
	}
}